<template lang="pug">
v-container(fluid)
  cadastral-adjacency-manager
</template>

<script>
import CadastralAdjacencyManager from '@/components/cadastral/CadastralAdjacencyManager';

export default {
  name: 'CadastralAdjacencyView',

  components: {
    CadastralAdjacencyManager,
  },

  data() {
    return {
    };
  },
};
</script>
